import React, { useState } from "react";

const ticketOptions = [
  { value: "Ticket Category 1", label: "Ticket Category 1" },
  { value: "Ticket Category 2", label: "Ticket Category 2" },
  { value: "Ticket Category 3", label: "Ticket Category 3" },
  { value: "Ticket Category 4", label: "Ticket Category 4" },
];

const RaiseTicket = () => {
  const [selectedTicketOption, setSelectedTicketOption] = useState(null);
  const [raiseTicketIsOpen, setRaiseTicketIsOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [description, setDescription] = useState("");

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (uploadedFiles.length + files.length <= 4) {
      const newFiles = files.map((file) => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    } else {
      alert("You can only upload up to 4 files.");
    }
  };

  const handleDeleteFile = (index) => {
    setUploadedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      URL.revokeObjectURL(updatedFiles[index].url); // Revoke the object URL
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };

  const toggleRaiseTicketOpen = () => {
    setRaiseTicketIsOpen(!raiseTicketIsOpen);
  };

  const selectRaiseTicketOption = (option) => {
    setSelectedTicketOption(option);
    setRaiseTicketIsOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedTicketOption || description.trim() === "") {
      // alert("Please select a category and provide a description.");
      return;
    }

    const formData = new FormData();
    formData.append("category", selectedTicketOption.value);
    formData.append("description", description);
    uploadedFiles.forEach((item, index) => {
      formData.append(`file${index}`, item.file);
    });

    try {
      const response = await fetch("/submit-ticket", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        // Handle successful response
        alert("Ticket submitted successfully!");
        setSelectedTicketOption(null);
        setDescription("");
        setUploadedFiles([]);
      } else {
        // Handle error response
        // alert("There was an error submitting your ticket. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("There was an error submitting your ticket. Please try again.");
    }
  };

  return (
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col px-[28px] pt-[41px] pb-[40px]">
      <h3 className="w-[109px] h-[27px] font-semibold text-[18px] text-start text-black">
        Raise Ticket
      </h3>
      <hr className="w-[206px] h-[2px] bg-[#FF6300] mt-[10px] rounded-full pb-[3px]" />
      <div className="w-full overflow-y-scroll h-auto py-[3px] px-[3px] mt-[21px]">
        <div className="w-[949px] h-auto bg-white rounded-[10px] pt-[19px] pl-[26px] pr-[23px] pb-[27px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <form onSubmit={handleSubmit}>
            <h4 className="w-[114px] h-[21px] font-semibold text-[14px] text-black">
              Select Category
            </h4>

            <div className="relative">
              <button
                onClick={toggleRaiseTicketOpen}
                className="flex flex-row items-center justify-between border-black w-[265px] h-[45px] bg-white drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[5px] p-[12px] mt-[10px] font-medium text-[14px] text-black text-start"
              >
                {selectedTicketOption
                  ? selectedTicketOption.label
                  : "Select Category"}
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.81795 5.36389C4.20208 5.72215 4.79792 5.72215 5.18205 5.36389L8.27282 2.48131C8.9367 1.86214 8.49857 0.75 7.59077 0.75H1.40923C0.501428 0.75 0.0632989 1.86214 0.72718 2.48131L3.81795 5.36389Z"
                    fill="black"
                  />
                </svg>
              </button>
              {raiseTicketIsOpen && (
                <div className="absolute z-10 mt-2 w-[265px] bg-white border border-gray-300 rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                  {ticketOptions.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => selectRaiseTicketOption(option)}
                      type="button"
                      className="block w-full py-2 px-4 font-medium text-[12px] text-black hover:text-[#FF6300] focus:outline-none"
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <h4 className="w-[82px] h-[21px] font-semibold text-[14px] text-black text-start mt-[20px]">
              Description
            </h4>

            <textarea
              name="Description"
              id="Description"
              rows={5}
              placeholder="Describe your issue in detail."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-[900px] h-[136px] p-[15px] border rounded-[5px] placeholder:w-[826px] placeholder:h-[100px] placeholder:text-[14px] placeholder:text-[#D9D9D9] placeholder:font-medium font-medium text-[14px] text-black resize-none mt-[11px]"
            ></textarea>

            <h4 className="w-[94px] h-[21px] font-semibold text-[14px] text-black text-start mt-[23px]">
              Attachments
            </h4>

            <p className="w-[371px] h-[18px] text-start text-black font-medium text-[12px] mt-[5px]">
              Add supporting files to help us understand your issues better.
            </p>

            <div className="w-[900px] h-[167px] border rounded-[5px] py-[21px] flex flex-col items-center justify-center mt-[13px]">
              <input
                id="fileUpload"
                type="file"
                multiple
                onChange={handleFileChange}
                className="hidden"
              />
              <div className="flex flex-col items-center justify-center h-[124px] gap-y-[16px] w-[206px]">
                <svg
                  width="62"
                  height="62"
                  viewBox="0 0 62 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48.2074 28.2391C48.2074 28.0938 48.2316 27.9484 48.2316 27.8031C48.2316 19.932 41.959 13.5625 34.2211 13.5625C28.6387 13.5625 23.8434 16.8805 21.591 21.6758C20.6102 21.1793 19.5082 20.8887 18.3457 20.8887C14.7734 20.8887 11.7945 23.5406 11.2254 27.0039C6.93867 28.4812 3.875 32.5863 3.875 37.418C3.875 43.4969 8.73086 48.4375 14.7129 48.4375H27.125V38.75H21.2883L31 28.6145L40.7117 38.7379H34.875V48.4254H48.2316C53.7051 48.4254 58.125 43.8844 58.125 38.3262C58.125 32.768 53.6809 28.2512 48.2074 28.2391Z"
                    fill="#FFC785"
                  />
                </svg>

                <span className="w-[206px] h-[46px] text-center text-black font-medium text-[12px] leading-[23px]">
                  Drag your product images here or{" "}
                  <label
                    htmlFor="fileUpload"
                    className="text-[#FF6300] font-semibold text-[12px] cursor-pointer"
                  >
                    click here to add
                  </label>
                </span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4 mt-4">
              {uploadedFiles.map((file, index) => (
                // <div
                //   key={index}
                //   className="w-[200px] h-[140px] border rounded-[5px] flex items-center justify-center relative mb-4"
                // >
                //   <span
                //     className="absolute top-2 right-2 cursor-pointer text-red-500"
                //     onClick={() => handleDeleteFile(index)}
                //   >
                //     &times;
                //   </span>
                //   <span className="text-[12px] text-black">{file.name}</span>
                // </div>
                <div key={index} className="relative">
                  <img
                    src={file.url}
                    alt={`Uploaded ${index + 1}`}
                    className="w-[200px] h-[140px] rounded-[5px] border flex items-center justify-center"
                  />
                  <button
                    type="button"
                    onClick={() => handleDeleteFile(index)}
                    className="absolute top-2 right-2 p-1 bg-red-500 text-white w-[25px] h-[25px] flex items-center justify-center rounded-full"
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>

            <div className="w-full flex justify-center mt-[24px]">
              <button type="submit" className="w-[122px] h-[42px] font-semibold text-[14px] flex items-center justify-center text-white rounded-[5px] bg-[#FF6300]">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RaiseTicket;
